import reducer from "./reducers";

export { default as operations } from "./operations";

export default reducer;
